// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /league/conference-list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeLeagueConferenceListBody,
  typeLeagueConferenceListOutput200,
} from "../../sdk/league/postLeagueConferenceList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildLeagueConferenceListQueryKey(
  payload: typeLeagueConferenceListBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueId:${JSON.stringify(payload.leagueId)}`);
  return [
    "post:league:leagueConferenceList",
    "svc:sports-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeLeagueConferenceListOutput200,
    unknown,
    typeLeagueConferenceListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useLeagueConferenceList(
  payload: typeLeagueConferenceListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildLeagueConferenceListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postLeagueConferenceList(payload),
    ...resolvedOptions,
  });
}
